import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataEnum,
  ODataDecimal,
  ODataBoolean,
  ODataDateTime,
} from "pbas-vue-components";
import { translate2 } from "../trans2";
import { formatBytes } from "../utils/file";
import { i18n } from "@/plugins/i18n";
import store from "@/store";

const PlanFilesHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "HasHistory",
    type: new ODataBoolean("HasHistory"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Current/Translations[]/Name", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current) {
          return "";
        }
        return translate2(item.Current, "Name");
      },
    }),
    allowVisibilityChange: true,
    sortable: false,
    visible: true,
    version: 3,
  }),
  new ODataHeader({
    title: "components.inmemorydependants.effective_date",
    type: new ODataDate("Current/EffectiveDate"),
  }),
  new ODataHeader({
    title: "headers.pendinghourstasks.created_by",
    type: new ODataString("Current/User"),
  }),
  new ODataHeader({
    title: "headers.member_files.created_on",
    type: new ODataDateTime("Current/Timestamp"),
  }),
  new ODataHeader({
    title: "headers.member_files.downloaded",
    type: new ODataBoolean("Current/Downloaded"),
  }),
  new ODataHeader({
    title: "headers.member_files.downloaded_at",
    type: new ODataDate("Current/DownloadedAt"),
  }),
  new ODataHeader({
    title: "globals.category",
    type: new ODataEnum("FileCategory", {
      getString: (item) => {
        return i18n.t("enums." + item.FileCategory);
      },
      dropdownItems: store.getters["plansMembers/options"]
        ? store.getters["plansMembers/options"].Enums.PlanFileCategory
        : [],
    }),
  }),
  new ODataHeader({
    title: "globals.type",
    type: new ODataString("Current/Translations[]/FileSegment/FileType", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current.Translations) {
          return "";
        }
        return translate2(item.Current, "FileSegment").FileType;
      },
    }),
    sortable: false,
    version: 1,
  }),
  new ODataHeader({
    title: "headers.member_files.size",
    type: new ODataDecimal("Current/Translations[]/FileSegment/FileSize", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current.Translations) {
          return "";
        }
        let size = translate2(item.Current, "FileSegment").FileSize;
        size = (size / 1024).toFixed(2) + " KB";
        return size;
      },
    }),
    sortable: false,
    version: 1,
  }),
  new ODataHeader({
    title: "globals.employer",
    type: new ODataString("Employer/Current/Translations[]/Name", {
      getString: (item) => {
        if (
          !item ||
          !item.Employer ||
          !item.Employer.Current ||
          !item.Employer.Current.Name ||
          item.Employer.Current.Name === ""
        )
          return "";
        return translate2(item.Employer.Current, "Name");
      },
    }),
  }),
  new ODataHeader({
    title: "Employer/Current/Translations[]/LanguageCode",
    type: new ODataString("Employer/Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Store/Current/Translations[]/LanguageCode",
    type: new ODataString("Store/Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/FileSegment/PhysicalFileId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/FileSegment/FileName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
const NoManagedHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "HasHistory",
    type: new ODataBoolean("HasHistory"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.category",
    type: new ODataEnum("FileCategory", {
      getString: (item) => {
        return i18n.t("enums." + item.FileCategory);
      },
      dropdownItems: store.getters["plansMembers/options"]
        ? store.getters["plansMembers/options"].Enums.PlanFileCategory
        : [],
    }),
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Current/Translations[]/Name", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current) {
          return "";
        }
        return translate2(item.Current, "Name");
      },
    }),
    allowVisibilityChange: true,
    sortable: false,
    visible: true,
    version: 3,
  }),
  new ODataHeader({
    title: "globals.employer",
    type: new ODataString("Employer/Current/Translations[]/Name", {
      getString: (item) => {
        if (
          !item ||
          !item.Employer ||
          !item.Employer.Current ||
          !item.Employer.Current.Name ||
          item.Employer.Current.Name === ""
        )
          return "";
        return translate2(item.Employer.Current, "Name");
      },
    }),
  }),
  new ODataHeader({
    title: "Employer/Current/Translations[]/LanguageCode",
    type: new ODataString("Employer/Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Store/Current/Translations[]/LanguageCode",
    type: new ODataString("Store/Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.inmemorydependants.effective_date",
    type: new ODataDate("Current/EffectiveDate"),
    visible: false,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    title: "headers.pendinghourstasks.created_by",
    type: new ODataString("Current/User"),
  }),
  new ODataHeader({
    title: "headers.member_files.created_on",
    type: new ODataDateTime("Current/Timestamp"),
  }),
  new ODataHeader({
    title: "headers.member_files.downloaded",
    type: new ODataBoolean("Current/Downloaded"),
  }),
  new ODataHeader({
    title: "headers.member_files.downloaded_at",
    type: new ODataDate("Current/DownloadedAt"),
  }),
  new ODataHeader({
    title: "globals.type",
    type: new ODataString("Current/Translations[]/FileSegment/FileType", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current.Translations) {
          return "";
        }
        return translate2(item.Current, "FileSegment").FileType;
      },
    }),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    version: 2,
  }),
  new ODataHeader({
    title: "headers.member_files.size",
    type: new ODataDecimal("Current/Translations[]/FileSegment/FileSize", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current.Translations) {
          return "";
        }
        let size = translate2(item.Current, "FileSegment").FileSize;
        size = (size / 1024).toFixed(2) + " KB";
        return size;
      },
    }),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    version: 2,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/FileSegment/PhysicalFileId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/FileSegment/FileName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
const NoManagedEmployerHeaders = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "HasHistory",
    type: new ODataBoolean("HasHistory"),
    sortable: false,
    visible: false,
    searchable: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.category",
    type: new ODataEnum("FileCategory", {
      getString: (item) => {
        return i18n.t("enums." + item.FileCategory);
      },
      dropdownItems: store.getters["plansMembers/options"]
        ? store.getters["plansMembers/options"].Enums.PlanFileCategory
        : [],
    }),
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Current/Translations[]/Name", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current) {
          return "";
        }
        return translate2(item.Current, "Name");
      },
    }),
    allowVisibilityChange: true,
    sortable: false,
    visible: true,
    version: 3,
  }),
  new ODataHeader({
    title: "globals.employer",
    type: new ODataString("Employer/Current/Translations[]/Name", {
      getString: (item) => {
        if (
          !item ||
          !item.Employer ||
          !item.Employer.Current ||
          !item.Employer.Current.Name ||
          item.Employer.Current.Name === ""
        )
          return "";
        return translate2(item.Employer.Current, "Name");
      },
    }),
  }),
  new ODataHeader({
    title: "Employer/Current/Translations[]/LanguageCode",
    type: new ODataString("Employer/Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Store/Current/Translations[]/LanguageCode",
    type: new ODataString("Store/Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.inmemorydependants.effective_date",
    type: new ODataDate("Current/EffectiveDate"),
    visible: false,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    title: "headers.pendinghourstasks.created_by",
    type: new ODataString("Current/User"),
  }),
  new ODataHeader({
    title: "headers.member_files.created_on",
    type: new ODataDateTime("Current/Timestamp"),
  }),
  new ODataHeader({
    title: "headers.member_files.pay_period_start_date",
    type: new ODataDate("Current/PeriodStartDate"),
  }),
  new ODataHeader({
    title: "headers.member_files.pay_period_end_date",
    type: new ODataDate("Current/PeriodEndDate"),
  }),
  new ODataHeader({
    title: "headers.member_files.downloaded",
    type: new ODataBoolean("Current/Downloaded"),
  }),
  new ODataHeader({
    title: "headers.member_files.downloaded_at",
    type: new ODataDate("Current/DownloadedAt"),
  }),
  new ODataHeader({
    title: "globals.type",
    type: new ODataString("Current/Translations[]/FileSegment/FileType", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current.Translations) {
          return "";
        }
        return translate2(item.Current, "FileSegment").FileType;
      },
    }),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    version: 2,
  }),
  new ODataHeader({
    title: "headers.member_files.size",
    type: new ODataDecimal("Current/Translations[]/FileSegment/FileSize", {
      getString: (item) => {
        if (!item || !item.Current || !item.Current.Translations) {
          return "";
        }
        let size = translate2(item.Current, "FileSegment").FileSize;
        size = (size / 1024).toFixed(2) + " KB";
        return size;
      },
    }),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    version: 2,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/FileSegment/PhysicalFileId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "Translations[]/LanguageCode",
    type: new ODataString("Current/Translations[]/FileSegment/FileName"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
function getPlanFilesHeaders(planType, mode) {
  if (mode === "plan") {
    if (planType === "NoManaged") {
      return NoManagedHeaders;
    }
    return PlanFilesHeaders;
  }
  return NoManagedEmployerHeaders;
}
export default getPlanFilesHeaders;
